import { createContext, useContext } from "react";
import { useStrategyTabs } from "./useStrategyTabs";

type StrategyTabsContextValue = ReturnType<typeof useStrategyTabs>;

const StrategyTabsContext = createContext<StrategyTabsContextValue | null>(
  null,
);

export function StrategyTabsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useStrategyTabs();
  return (
    <StrategyTabsContext.Provider value={value}>
      {children}
    </StrategyTabsContext.Provider>
  );
}

export function useStrategyTabsContext(): StrategyTabsContextValue {
  const ctx = useContext(StrategyTabsContext);
  if (!ctx) {
    throw new Error(
      "useStrategyTabsContext must be used within a StrategyTabsProvider",
    );
  }
  return ctx;
}

export function useOptionalStrategyTabsContext(): StrategyTabsContextValue | null {
  return useContext(StrategyTabsContext);
}
